// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__fAA0Z","narrowContainer":"styles_narrowContainer__TZDE3"};